var map = {
	"./arnav khare.jpg": 9879,
	"./dev vats.jpeg": 4316,
	"./garima-singh.jpg": 8681,
	"./nikhil kumar.jpg": 7461,
	"./nikita.jpeg": 9575,
	"./pratham-puri.jpg": 5432,
	"./sachin-rout.jpg": 53,
	"./shrey-paul.jpg": 7626,
	"./shreyashi-das.jpg": 2175,
	"./tejas.jpg": 5595
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7719;